<template>
  <div class="basic-steps">
    <ASteps :current="stepCurrent">
      <AStep v-for="item in steps" :key="item.title" :title="item.title" />
    </ASteps>
    <div class="steps-content">
      <!-- {{ steps[stepCurrent].content }} -->
      <Detection v-if="stepCurrent == 0"></Detection>
      <Submit v-if="stepCurrent == 1" ref="submitRef"></Submit>
      <Pay v-if="stepCurrent == 2" ref="payRef" :trade-id="tradeId" @refreshqrcode="next"></Pay>
    </div>
    <div class="steps-action">
      <AButton
        v-if="stepCurrent < steps.length - 1"
        type="primary"
        @click="next"
      >
        下一步
      </AButton>
      <AButton
        v-if="stepCurrent == steps.length - 1"
        type="primary"
        @click="$message.success('处理完成!')"
      >
        完成
      </AButton>
      <AButton v-if="stepCurrent > 0" style="margin-left: 8px" @click="prev">
        上一步
      </AButton>
    </div>

  </div>
</template>

<script>
import Detection from '@/components/Detection'
import Submit from '@/components/Submit'
import Pay from '@/components/Pay'
import { Steps, Button } from 'ant-design-vue'
import moment from 'moment'
export default {
  name: 'Step',
  components: {
    ASteps: Steps,
    AStep: Steps.Step,
    AButton: Button,
    Detection,
    Submit,
    Pay
  },
  data () {
    return {
      stepCurrent: 0,
      tradeId: null,
      steps: [
        {
          title: '选择检测库',
          content: 'First-content',
        },
        {
          title: '上传文档',
          content: 'Second-content',
        },
        {
          title: '支付',
          content: 'third-content',
        },
        {
          title: '完成',
          content: 'four-content',
        },
        {
          title: '下载报告',
          content: 'Last-content',
        },
      ],

    }
  },
  methods: {
    next () {
      if (this.stepCurrent === 0) {
        this.$store.commit('check/saveChoosedPrd', {
          product: this.$store.state.check.activeObj
        }
        )
        this.stepCurrent++
      } else if (this.stepCurrent === 1) {
        const _this = this.$refs.submitRef
        _this && _this.form.validateFields((err, values) => {
          if (err) {
            return
          }
          if (values.publishdate) {
            values.publishdate = moment(values.publishdate).format('YYYY-MM-DD')
          }
          if (_this.$store.state.check.tabKey === '1') {
            const fileList = this.$store.state.check.fileList
            if (!fileList.length) {
              _this.$message.error('请选择论文')
              return
            }
            _this.$store.dispatch('check/creatTrade', {
              payload: {
                ...values,
                ...fileList[0],
                type: _this.$store.state.check.activeObj.userProductCode,
              },
              callback: (res) => {
                if (res.error_code === '10000') {
                  _this.$message.success('论文检测提交成功')
                  this.tradeId = res.result.tradeId
                  // this.$router.push(`/payform/${res.result.tradeId}`)
                  this.$store.commit('check/saveFieldsValue', {
                    fieldsValue: _this.form.getFieldsValue()
                  })
                  this.stepCurrent++
                }
              }
            })
          } else {
            const inputCount = _this.$store.state.check.inputCount
            let bigSize = 300000
            if (_this.$store.state.check.activeObj.maxNum) {
              bigSize = _this.$store.state.check.activeObj.maxNum
            }
            // console.log(bigSize)
            if (inputCount < 500 || inputCount > bigSize) {
              _this.$message.error(`填写需要检测内容，字数限制大于500字，小于${bigSize}字`)
              return
            }
            _this.$store.dispatch('check/creatTrade', {
              payload: {
                ...values,
                type: _this.$store.state.check.activeObj.userProductCode
              },
              callback: (res) => {
                if (res.error_code === '10000') {
                  // this.$router.push(`/payform/${res.result.tradeId}`)
                  _this.$message.success('论文检测提交成功')
                  this.tradeId = res.result.tradeId
                  this.$store.commit('check/saveFieldsValue', {
                    fieldsValue: _this.form.getFieldsValue()
                  })
                  this.stepCurrent++
                }
              }
            })
          }

        })
      } else if (this.stepCurrent === 2) {
        const _this = this.$refs.payRef
        const paytype = _this.value
        _this && _this.form.validateFields((err, values) => {
          if (err) {
            return
          }
          if (_this.value !== 'TMALL') {
            _this.timeOut = false
            _this.visible = true
            _this.qrurl = null
          }
          if(paytype==="OFFICIAl"){
            _this.$store.dispatch('check/getOfficialUrl', {
              payload: {
                tradeId: this.tradeId,
              },
              callback: (res) => {
                if (paytype !== 'TMALL' && res.error_code === '10000' && res.result.payUrl) {
                  _this.qrurl = res.result.payUrl
                  // _this.$refs.qrcode.innerHTML = ''
                  setTimeout( _this.checkPay(), 2000)
                } else if (res.error_code === '10000') {
                  // _this.$router.push({path:`/reports/${values.authcode}`})
                  this.stepCurrent++
                }
              }
            })
          }else{
            _this.$store.dispatch('check/creatPayTrade', {
              payload: {
                ...values,
                tradeId: this.tradeId,
                payType: _this.value
              },
              callback: (res) => {
                if (paytype !== 'TMALL' && res.error_code === '10000' && res.result.payUrl) {
                  _this.qrurl = res.result.payUrl
                  _this.$refs.qrcode.innerHTML = ''
                  _this.creatQrCode()
                  // this.$router.push({path:`/down?tradCode=${res.data.transactionId}`})
                } else if (res.error_code === '10000') {
                  // _this.$router.push({path:`/reports/${values.authcode}`})
                  this.stepCurrent++
                }
              }
            })
          }
        })
      }

    },
    prev () {
      if (this.stepCurrent === 1) {
        const _this = this.$refs.submitRef
        this.$store.commit('check/saveFieldsValue', {
          fieldsValue: _this.form.getFieldsValue()
        })
        // this.stepCurrent++;
      }
      this.stepCurrent--
    },
    optinon () {

    }
  },
}
</script>
<style scoped lang="less">
// .basic-steps {
//   width: 70%;
//   height: 100%;
//   margin: 10px 0 10% 12%;
//   text-align: center;
// }
.steps-content {
  // display: inline-block;
  // width: 100%;
  margin-top: 30px;
  padding: 20px;
  background-color: #fafafa;
  overflow: hidden;
  // background-color: #;
  // filter: Alpha(opacity=50);
  // position: static; /* IE6、7、8只能设置position:static(默认属性) ，否则会导致子元素继承Alpha值 */
  // *zoom: 1; /* 激活IE6、7的haslayout属性，让它读懂Alpha */
}
.steps-action {
  // clear: both;
  margin-top: 25px;
  text-align: center;
}
</style>
